import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { message } from "antd";

import imageBtn from "../../../../Assets/assetsnew/image-add-line.svg";
import clientBtn from "../../../../Assets/assetsnew/image-client-new.svg";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";

import PCEditProjectInfo from "./PCEditProjectInfo.jsx";
import PCEditClientInfo from "./PCEditClientInfo.jsx";
import PCEditBusinessInfo from "./PCEditBusinessInfo.jsx";

import AddSection from "./AddSection/AddSection.jsx";
import Services from "./Services/Services.jsx";
import BillingSchedules from "./BillingSchedules/BillingSchedules.jsx";
import Signature from "./Signatures/Signature.jsx";

import Text from "./AddSection/Text/Text.jsx";
// import Image from "./AddSection/Image/Image";
// import Table from "./AddSection/Table/Table";
// import Column from "./AddSection/Column/Column";
import File from "./AddSection/File/File";

import Styled from "./ReviewStyles";
import TextStyles from "../../../../Constants/TextStyles";
import Colors from "../../../../Constants/Colors";
import SignProposal from "./Signatures/SignProposal";

import { diffDate, findPrimaryContact } from "../../Commons/utils";
import BrandAndLogoModal from "./BrandAndLogoModal";
import { useHistory, useLocation } from "react-router-dom";
import AgreementNotes from "../../../UIs/AgreementNotes.jsx";

const Review = () => {
  const history = useHistory();
  const location = useLocation();
  const pathname =
    location && location.pathname.split("/").slice(0, -1).join("/");

  const [showBrandAndLogoModal, setSshowBrandAndLogoModal] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [showClientModal, setShowClientModal] = useState(false);
  const [showBusinessModal, setShowBusinessModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const data = useSelector((state) => state.auth.data);
  const businessInfoData = useSelector((state) => state.auth.businessInfoData);
  const brandAndLogoData = useSelector((state) => state.auth.brandAndLogoData);
  const { selectedData } = useSelector((state) => state.proposalAndContract);

  const primaryContact = findPrimaryContact(selectedData);

  const {
    street,
    suite,
    city,
    state,
    country,
    zip_code,
    tax_id_label,
    tax_id_number,
  } = (selectedData && selectedData.client_id) || {};

  const clientAddress = [street, suite, city, zip_code, state, country]
    .filter((elem) => elem)
    .join(", ");

  const {
    street: businessStreet,
    suite: businessSuite,
    city: businessCity,
    state: businessState,
    country: businessCountry,
    zip_code: businessZipcode,
    tax_id_label: businessTaxIDLabel,
    tax_id_number: businessTaxIDNumber,
  } = businessInfoData || {};

  const businessAddress = [
    businessStreet,
    businessSuite,
    businessCity,
    businessZipcode,
    businessState,
    businessCountry,
  ]
    .filter((elem) => elem)
    .join(", ");

  const nextPageHandler = () => {
    if (!primaryContact) {
      return message.error("Please select the primary contact");
    }

    if (
      (selectedData && selectedData.signature && selectedData.signature.text) ||
      (selectedData &&
        selectedData.signature &&
        selectedData.signature.image.image_name &&
        selectedData.signature.image.image_url)
    ) {
      if (selectedData && selectedData.section === "Proposal and contract") {
        history.push(`${pathname}/reviewContract`);
      } else {
        history.push(`${pathname}/send`);
      }
    } else {
      setShowModal(true);
    }
  };

  return (
    <div className="px-lg-4 px-md-4 px-sm-3 px-2">
      <div
        className="d-flex justify-content-center w-100"
        style={{ contain: "content" }}
      >
        <div style={{ width: "100%", maxWidth: 700, marginTop: "2rem" }}>
          <Styled.ReviewContainer
            style={{
              borderTop: `4px solid ${Colors.primary}`,
            }}
          >
            <Styled.BrandLogoBox
              logoAlignment={
                brandAndLogoData &&
                brandAndLogoData.brand_logo &&
                brandAndLogoData.brand_logo.file_url
                  ? brandAndLogoData.logo_alignment
                  : "center"
              }
              onClick={() => setSshowBrandAndLogoModal(true)}
            >
              <BorderColorOutlinedIcon
                sx={{
                  cursor: "pointer",
                  color: Colors.font2,
                  opacity: 0.8,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              />

              {brandAndLogoData &&
              brandAndLogoData.brand_logo &&
              brandAndLogoData.brand_logo.file_url ? (
                <img
                  src={brandAndLogoData.brand_logo.file_url}
                  alt="brand logo"
                  style={{ maxHeight: 100 }}
                />
              ) : (
                <>
                  <div>
                    <img
                      src={imageBtn}
                      alt="imageBtn"
                      style={{ width: 56, height: 56 }}
                    />
                  </div>

                  <TextStyles.FontSize20px className="d-flex justify-content-center text-center mt-3">
                    Brand & Logo
                  </TextStyles.FontSize20px>
                </>
              )}
            </Styled.BrandLogoBox>

            <Styled.ReviewBox className="mt-4">
              <Styled.EditProject>
                <div className="d-flex gap-2 gap-md-3 align-items-center">
                  <BorderColorOutlinedIcon
                    onClick={() => setShowProjectModal(true)}
                    sx={{
                      cursor: "pointer",
                      color: Colors.font2,
                      opacity: 0.8,
                      "&:hover": {
                        opacity: 1,
                      },
                    }}
                  />

                  <div style={{ maxWidth: 35.2 }}>
                    <img className="w-100" src={clientBtn} alt="clientBtn" />
                  </div>

                  <TextStyles.FontSize18px className="three-dots fw-medium">
                    {selectedData && selectedData.project_name}
                  </TextStyles.FontSize18px>
                </div>

                <div className="d-flex gap-2 justify-content-start align-items-center mt-4">
                  <TextStyles.FontSize16px className="fw-medium">
                    Starts:
                  </TextStyles.FontSize16px>

                  <TextStyles.FontSize14px
                    className="d-flex"
                    style={{ minWidth: 50 }}
                  >
                    <span className="three-dots">
                      {moment(
                        selectedData && selectedData.project_start_date
                      ).format("DD MMM YYYY")}{" "}
                    </span>
                  </TextStyles.FontSize14px>
                </div>

                {selectedData && selectedData.project_end_date ? (
                  <div className="d-flex gap-2 justify-content-start align-items-center mt-2">
                    <TextStyles.FontSize16px className="fw-medium">
                      Ends:
                    </TextStyles.FontSize16px>
                    <TextStyles.FontSize14px
                      className="d-flex"
                      style={{ minWidth: 50 }}
                    >
                      <span className="three-dots">
                        {moment(selectedData.project_end_date).format(
                          "DD MMM YYYY"
                        )}
                      </span>
                    </TextStyles.FontSize14px>
                  </div>
                ) : (
                  <div className="d-flex gap-2 justify-content-start align-items-center mt-2">
                    <TextStyles.FontSize16px className="fw-medium">
                      Ends:
                    </TextStyles.FontSize16px>
                    <TextStyles.FontSize14px>On going</TextStyles.FontSize14px>
                  </div>
                )}

                {selectedData &&
                  selectedData.project_end_date &&
                  selectedData.project_start_date && (
                    <div className="d-flex gap-2 justify-content-start align-items-center mt-2">
                      <TextStyles.FontSize16px className="fw-medium">
                        Duration:
                      </TextStyles.FontSize16px>
                      <TextStyles.FontSize14px
                        className="d-flex"
                        style={{ minWidth: 30 }}
                      >
                        <span className="three-dots">
                          {diffDate(
                            selectedData.project_end_date,
                            selectedData.project_start_date
                          )}
                        </span>
                      </TextStyles.FontSize14px>
                    </div>
                  )}
              </Styled.EditProject>

              <div
                className="my-3"
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#a9abb3",
                }}
              />

              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="edit_client_info">
                    <div className="d-flex justify-content-between align-items-center">
                      <TextStyles.GreyFont18px
                        className="fw-medium"
                        style={{ color: Colors.primary }}
                      >
                        To
                      </TextStyles.GreyFont18px>
                      <BorderColorOutlinedIcon
                        className="edit_client_infoBtn"
                        onClick={() => setShowClientModal(true)}
                        sx={{
                          cursor: "pointer",
                          color: Colors.font2,
                          opacity: 0.8,
                          "&:hover": {
                            opacity: 1,
                          },
                        }}
                      />
                    </div>
                    <TextStyles.FontSize18px className="mt-2 fw-medium three-dots">
                      {selectedData &&
                        selectedData.client_id &&
                        selectedData.client_id.company_name}
                    </TextStyles.FontSize18px>
                    <TextStyles.FontSize14px className="mt-2 three-dots">
                      {/* <span className="fw-medium">Name: </span> */}
                      {primaryContact && primaryContact.contact_name}
                    </TextStyles.FontSize14px>
                    <TextStyles.FontSize14px className="mt-1">
                      {/* <span className="fw-medium">Email: </span> */}
                      {primaryContact && primaryContact.email}
                    </TextStyles.FontSize14px>
                    {clientAddress ? (
                      <TextStyles.FontSize14px className="mt-1">
                        {/* <span className="fw-medium">Address: </span> */}
                        {clientAddress}
                      </TextStyles.FontSize14px>
                    ) : (
                      ""
                    )}

                    {tax_id_label ? (
                      <TextStyles.FontSize14px className="mt-1">
                        <span>Tax Label: </span>
                        {tax_id_label}
                      </TextStyles.FontSize14px>
                    ) : (
                      ""
                    )}

                    {tax_id_number ? (
                      <TextStyles.FontSize14px className="mt-1">
                        <span>Tax ID: </span>
                        {tax_id_number}
                      </TextStyles.FontSize14px>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div
                  className="d-flex d-sm-none my-3"
                  style={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: " #a9abb3",
                  }}
                />
                <div className="col-12 col-sm-6">
                  <div className="edit_your_info">
                    <div className="d-flex justify-content-between align-items-center">
                      <TextStyles.GreyFont18px
                        className="fw-medium"
                        style={{ color: Colors.primary }}
                      >
                        From
                      </TextStyles.GreyFont18px>
                      <BorderColorOutlinedIcon
                        className="edit_your_infoBtn"
                        onClick={() => setShowBusinessModal(true)}
                        sx={{
                          cursor: "pointer",
                          color: Colors.font2,
                          opacity: 0.8,
                          "&:hover": {
                            opacity: 1,
                          },
                        }}
                      />
                    </div>
                    <TextStyles.FontSize18px className="d-flex justify-content-start mt-2 fw-medium">
                      {businessInfoData &&
                      businessInfoData.business_name !== undefined
                        ? businessInfoData.business_name
                        : data && `${data.firstName} ${data.lastName}`}
                    </TextStyles.FontSize18px>
                    <TextStyles.FontSize14px className="mt-2">
                      {/* <span className="fw-medium">Email: </span> */}
                      {data && data.email}
                    </TextStyles.FontSize14px>

                    {businessAddress ? (
                      <TextStyles.FontSize14px className="mt-1">
                        {/* <span className="fw-medium">Address: </span> */}
                        {businessAddress}
                      </TextStyles.FontSize14px>
                    ) : (
                      ""
                    )}

                    {businessTaxIDLabel ? (
                      <TextStyles.FontSize14px className="mt-1">
                        <span>Tax Label: </span>
                        {businessTaxIDLabel}
                      </TextStyles.FontSize14px>
                    ) : (
                      ""
                    )}

                    {businessTaxIDNumber ? (
                      <TextStyles.FontSize14px className="mt-1">
                        <span>Tax ID: </span>
                        {businessTaxIDNumber}
                      </TextStyles.FontSize14px>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </Styled.ReviewBox>

            {/* <AddSection selectedData={selectedData} position="one" /> */}

            {/* {selectedData &&
              selectedData.add_section_text_one &&
              selectedData.add_section_text_one.map((data, index) => {
                return (
                  <Text
                    key={index}
                    data={data}
                    pc_id={selectedData._id}
                    position="one"
                  />
                );
              })}

            {selectedData &&
              selectedData.add_section_image_one &&
              selectedData.add_section_image_one.map((data, index) => {
                return (
                  <Image
                    key={index}
                    data={data}
                    position="one"
                    pc_id={selectedData._id}
                  />
                );
              })}

            {selectedData &&
              selectedData.add_section_table_one &&
              selectedData.add_section_table_one.map((data, index) => {
                return (
                  <Table
                    key={index}
                    data={data}
                    position="one"
                    pc_id={selectedData._id}
                  />
                );
              })}

            {selectedData &&
              selectedData.add_section_column_one &&
              selectedData.add_section_column_one.map((data, index) => {
                return (
                  <Column
                    key={index}
                    data={data}
                    position="one"
                    pc_id={selectedData._id}
                  />
                );
              })}

            {selectedData &&
              selectedData.add_section_file_one &&
              selectedData.add_section_file_one.map((data, index) => {
                return (
                  <File
                    key={index}
                    data={data}
                    position="one"
                    pc_id={selectedData._id}
                  />
                );
              })} */}

            <Services selectedData={selectedData} />
            <BillingSchedules selectedData={selectedData} />

            <AddSection selectedData={selectedData} />

            {selectedData &&
              selectedData.add_section_text_two &&
              selectedData.add_section_text_two.length > 0 &&
              selectedData.add_section_text_two.map((data, index) => (
                <AgreementNotes key={data._id}>
                  <Text
                    key={index}
                    data={data}
                    // position="two"
                    pc_id={selectedData._id}
                  />
                </AgreementNotes>
              ))}

            {/* {selectedData &&
              selectedData.add_section_image_two &&
              selectedData.add_section_image_two.map((data, index) => {
                return (
                  <Image
                    key={index}
                    data={data}
                    position="two"
                    pc_id={selectedData._id}
                  />
                );
              })} */}

            {/* {selectedData &&
              selectedData.add_section_table_two &&
              selectedData.add_section_table_two.map((data, index) => {
                return (
                  <Table
                    key={index}
                    data={data}
                    position="two"
                    pc_id={selectedData._id}
                  />
                );
              })}

            {selectedData &&
              selectedData.add_section_column_two &&
              selectedData.add_section_column_two.map((data, index) => {
                return (
                  <Column
                    key={index}
                    data={data}
                    position="two"
                    pc_id={selectedData._id}
                  />
                );
              })} */}

            {selectedData &&
              selectedData.add_section_file_two &&
              selectedData.add_section_file_two.length > 0 && (
                <div
                  className="mt-4"
                  style={{
                    padding: "1.5rem",
                    border: "1px solid #a9abb3",
                    borderRadius: "0.75rem",
                  }}
                >
                  <TextStyles.FontSize18px className="fw-medium mb-3">
                    Attached Files
                  </TextStyles.FontSize18px>
                  {selectedData.add_section_file_two.map((data, index) => {
                    return (
                      <File
                        key={index}
                        data={data}
                        // position="two"
                        pc_id={selectedData._id}
                      />
                    );
                  })}
                </div>
              )}

            <Signature
              primaryContact={primaryContact}
              selectedData={selectedData}
              data={data}
              businessInfoData={businessInfoData}
            />
          </Styled.ReviewContainer>
        </div>
      </div>
      <Styled.SubmitButton onClick={nextPageHandler}>
        Continue
      </Styled.SubmitButton>
      {showBrandAndLogoModal && (
        <BrandAndLogoModal
          show={showBrandAndLogoModal}
          handleClose={() => setSshowBrandAndLogoModal(false)}
          brandAndLogoData={brandAndLogoData}
        />
      )}
      {showProjectModal && (
        <PCEditProjectInfo
          selectedData={selectedData}
          show={showProjectModal}
          handleClose={() => setShowProjectModal(false)}
        />
      )}
      {showClientModal && (
        <PCEditClientInfo
          selectedData={selectedData}
          show={showClientModal}
          handleClose={() => setShowClientModal(false)}
        />
      )}

      {showBusinessModal && (
        <PCEditBusinessInfo
          show={showBusinessModal}
          handleClose={() => setShowBusinessModal(false)}
          data={data}
          businessInfoData={businessInfoData}
        />
      )}
      {showModal && (
        <SignProposal
          show={showModal}
          handleClose={() => setShowModal(false)}
          selectedData={selectedData}
        />
      )}
    </div>
  );
};

export default Review;
